import enums from '@/utils/enums';
import requestService from '@/services/request';
import { NOTIFICATIONS } from '@/utils/constants';
import getSlipUrl from '@/services/getSlipUrl';
import notificationTypes from '@/utils/notificationTypes';
import { PAYMENT_SLIPS, UNIT } from '../../utils/constants';

export default {
  computed: {
    debitBlock() {
      return this.$store.getters[UNIT.GET_DEBIT_BLOCK];
    },
    toExpirePaymentSlips() {
      return this.$store.getters[PAYMENT_SLIPS.GET_TO_EXPIRE];
    },
    hasLateSlips() {
      return this.$store.getters[PAYMENT_SLIPS.HAS_LATE_SLIPS];
    },
    hasPayableLateSlips() {
      return this.$store.getters[PAYMENT_SLIPS.HAS_PAYABLE_LATE_SLIPS];
    },
    hasFuturePaymentSlips() {
      return this.$store.getters[PAYMENT_SLIPS.HAS_FUTURE_SLIPS];
    },
    hasPaymentSlipError() {
      return this.$store.getters[PAYMENT_SLIPS.HAS_SLIP_ERROR];
    },
    isLoadingPaymentSlips() {
      return this.$store.getters[PAYMENT_SLIPS.GET_IS_LOADING];
    },
    toExpireSlipsByContract() {
      return this.$store.getters[PAYMENT_SLIPS.GET_TO_EXPIRE_BY_CONTRACT];
    },
  },
  methods: {
    async getToExpirePaymentSlips(params) {
      return this.$store.dispatch(PAYMENT_SLIPS.FETCH_TO_EXPIRE, params);
    },

    async OnPayToExpireSlip(selectedUnit, slip, fromHome = false) {
      if (slip.ready) {
        if (slip.slipUrl.hash) {
          const url = getSlipUrl(slip.slipUrl.hash);
          try {
            window.location(url);
          } catch (error) {
            window.open(url, '_blank');
          }
        } else {
          window.open(slip.slipUrl);
        }
      } else {
        window.open('/boleto-indisponivel');
      }

      const notificationInfo = {
        ctx: this,
        notification: {
          id: slip.id.toString(),
          type: notificationTypes.TO_EXPIRE_SLIPS,
        },
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);
      const slipContract = selectedUnit.contracts.find(
        (contract) => contract.id === slip.contractId
      );
      const traceInfo = {
        contractId: slipContract.id,
        contractType: slipContract.type,
        detachedType: this.getContractTitle(slipContract),
        expirationDate: slip.expirationDate,
        serieId: slip.serieId,
        serieCode: slip.serieCode,
        parcelCode: slip.parcelCode,
        discountedValue: slip.discountedValue,
        ready: slip.ready,
        url: slip.slipUrl,
      };
      const { logTraceActions } = enums;
      const traceAction =
        logTraceActions[`toExpirePaymentSlipDownload${fromHome ? 'Home' : ''}`];
      this.createTrace(traceAction, traceInfo);
    },
    async sendSlipByEmailToExpire(item, email, fromHome = false) {
      console.log('sendSlipByEmailToExpire');

      const contractId = item.contractId;

      const data = {
        contractId,
        productCode: this.selectedUnit.product.code,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        solicitationType: 'toExpire',
        userEmail: email,
      };

      const url = process.env.SLIP_CHECK_FUNCTION;
      const res = await requestService(`${url}/sendSlipEmail`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      });

      const { emailSended } = res;
      if (emailSended) {
        const slipContract = this.selectedUnit.contracts.find(
          (contract) => contract.id === contractId
        );
        const traceInfo = {
          contractId: contractId,
          contractType: slipContract.type,
          detachedType: this.getContractTitle(slipContract),
          expirationDate: item.expirationDate,
          serieId: item.serieId,
          serieCode: item.serieCode,
          parcelCode: item.parcelCode,
          discountedValue: item.discountedValue,
          ready: item.ready,
          url: item.slipUrl,
        };
        const { logTraceActions } = enums;
        const traceAction =
          logTraceActions[`toExpirePaymentSlipEmail${fromHome ? 'Home' : ''}`];
        this.createTrace(traceAction, traceInfo);
      } else {
        console.error('Payment slip not ready');
      }
      return res;
    },
    async sendSlipBySmsToExpire(item, cellphone, fromHome = false) {
      console.log('sendSlipBySmsToExpire');

      const contractId = item.contractId;

      const data = {
        contractId,
        productId: this.selectedUnit.product.id,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        smsType: 'toExpireSlipRequested',
        userPhoneNumber: cellphone,
      };

      const url = process.env.SMS_API;
      return requestService(`${url}/addToQueue`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      })
        .then((res) => {
          const { count } = res;
          if (count) {
            const slipContract = this.selectedUnit.contracts.find(
              (contract) => contract.id === contractId
            );
            const traceInfo = {
              contractId: contractId,
              contractType: slipContract.type,
              detachedType: this.getContractTitle(slipContract),
              expirationDate: item.expirationDate,
              serieId: item.serieId,
              serieCode: item.serieCode,
              parcelCode: item.parcelCode,
              discountedValue: item.discountedValue,
              ready: item.ready,
              url: item.slipUrl,
              barcode: item.barcode,
              userCellphone: cellphone,
            };
            const { logTraceActions } = enums;
            const traceAction =
              logTraceActions[
                `toExpirePaymentSlipSms${fromHome ? 'Home' : ''}`
              ];
            this.createTrace(traceAction, traceInfo);
          }
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/toExpirePaymentSlip.js